export type QueryParams = Record<string, unknown> | object

const isDate = (value: unknown): value is Date => value instanceof Date

const appendValue = (
  searchParams: URLSearchParams,
  key: string,
  value: unknown
): void => {
  if (value === undefined || value === null || value === '') return

  if (Array.isArray(value)) {
    value.forEach(item => appendValue(searchParams, `${key}[]`, item))
    return
  }

  if (isDate(value)) {
    searchParams.append(key, value.toISOString())
    return
  }

  if (typeof value === 'object') {
    Object.entries(value as Record<string, unknown>).forEach(
      ([nestedKey, nestedValue]) => {
        appendValue(searchParams, `${key}[${nestedKey}]`, nestedValue)
      }
    )
    return
  }

  searchParams.append(key, String(value))
}

export const stringifyQueryParams = (params: QueryParams | null | undefined): string => {
  if (!params || typeof params !== 'object') return ''

  const searchParams = new URLSearchParams()

  Object.entries(params).forEach(([key, value]) => {
    appendValue(searchParams, key, value)
  })

  return searchParams.toString()
}
